import type { LandingTestimonialPublic } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { CompanyCaseCard } from './company-case-card';

interface HomeTestimonialsProps {
  /** 운영자가 랜딩 관리에서 등록한 기업 고객 사례 — 배열 순서가 노출 순서다. */
  readonly items: readonly LandingTestimonialPublic[];
}

/**
 * HOME 기업 고객 사례 — 다른 구역과 같은 왼쪽 정렬 머리말 아래 사례 카드를 한 줄(데스크톱 네 장, 태블릿 두 장)로 놓는다.
 * 운영자가 등록한 카드만 쓴다. 하나도 없으면 섹션을 그리지 않는다 — 상품 후기로 채우지 않는다(지어내지 않는다).
 * 로딩·실패는 조용히 생략한다(소개 성격).
 */
export const HomeTestimonials = ({ items }: HomeTestimonialsProps): ReactElement | null => {
  if (items.length === 0) return null;

  return (
    <section aria-labelledby="home-testimonials-heading" className="w-full px-5 sm:px-8 xl:px-14">
      {/* 다른 홈 구역과 같은 머리말 — 왼쪽 정렬, 영문 라벨 위에 한국어 문장 제목. */}
      <div className="flex flex-col gap-3">
        <p className="text-base text-muted-foreground sm:text-lg">Client Story</p>
        <h2
          id="home-testimonials-heading"
          className="text-[2rem] leading-tight font-bold tracking-[-0.03em] sm:text-[2.75rem]"
        >
          기업 고객과 함께한 제작 이야기
        </h2>
      </div>

      <ul className="mt-10 grid gap-x-6 gap-y-12 sm:mt-14 sm:grid-cols-2 lg:grid-cols-4">
        {items.map((item) => (
          <li key={item.id} className="min-w-0">
            <CompanyCaseCard item={item} />
          </li>
        ))}
      </ul>
    </section>
  );
};
